export default function formatCPF(cpf) {
    if (cpf) {
        cpf = cpf.toString().replace(/[^\d]/g, '');
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
}



